import { render } from "./RiskyStockTable.vue?vue&type=template&id=a0022a2e&scoped=true"
import script from "./RiskyStockTable.vue?vue&type=script&lang=js"
export * from "./RiskyStockTable.vue?vue&type=script&lang=js"

import "./RiskyStockTable.vue?vue&type=style&index=0&id=a0022a2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0022a2e"]])

export default __exports__